(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/filter-and-sort/assets/javascripts/components/sort.js') >= 0) return;  svs.modules.push('/components/casino-react/filter-and-sort/assets/javascripts/components/sort.js');
"use strict";

const {
  useEffect,
  useMemo,
  useCallback
} = React;
const {
  Accordion,
  AccordionItem,
  AccordionSummary,
  AccordionDetails
} = svs.ui.ReactAccordion;
const {
  useSetSearchParams,
  useSearchParams
} = svs.components.casino_react.hooks;
const {
  SortOption
} = svs.components.casino_react.filterAndSort.components;
const sortingOptions = svs.components.casino_react.common.utils.getSortingOptions();
const Sort = () => {
  const {
    sorting: sortingFromQueryParam
  } = useSearchParams();
  const {
    setSorting
  } = useSetSearchParams();
  const activeSorting = useMemo(() => {
    var _sortingOptions$find;
    const sorting = (_sortingOptions$find = sortingOptions.find(sortingOption => sortingOption.mode === sortingFromQueryParam)) !== null && _sortingOptions$find !== void 0 ? _sortingOptions$find : sortingOptions[0];
    return sorting;
  }, [sortingFromQueryParam]);
  const onSortingClick = useCallback(clickedSortingOption => {
    if (clickedSortingOption.mode.includes('default')) {
      setSorting('');
    } else {
      setSorting(clickedSortingOption.mode);
    }
  }, [setSorting]);
  useEffect(() => {
    if (sortingFromQueryParam && !activeSorting) {
      setSorting('');
    }
  }, [sortingFromQueryParam, activeSorting, setSorting]);
  return React.createElement("div", {
    className: "casino-filter-and-sort__sort-options"
  }, React.createElement(Accordion, {
    branding: "inverted",
    customer: "sport",
    isFlat: true
  }, React.createElement(AccordionItem, null, React.createElement(AccordionSummary, null, "Sortera: ".concat(activeSorting.name)), React.createElement(AccordionDetails, null, React.createElement("ul", {
    className: "sort-list"
  }, sortingOptions.map(sortingOption => React.createElement(SortOption, {
    isChecked: activeSorting.mode === sortingOption.mode,
    key: sortingOption.name,
    onClickCallback: onSortingClick,
    sortingOption: sortingOption
  })))))));
};
setGlobal('svs.components.casino_react.filterAndSort.components.Sort', Sort);

 })(window);